import { Box, styled } from "@mui/material";

// Add styled components for consistent markdown styling
export const StyledMarkdownContent = styled(Box)(({ theme }) => ({
  "& p": {
    ...theme.typography.textBase500,
    color: theme.palette.dsBase.v200,
    margin: "1em 0",
  },
  "& h1": {
    ...theme.typography.text5xl700,
    color: theme.palette.dsBase.v200,
    margin: "0.67em 0",
  },
  "& h2": {
    ...theme.typography.text4xl700,
    color: theme.palette.dsBase.v200,
  },
  "& h3": {
    ...theme.typography.text2xl700,
    color: theme.palette.dsBase.v200,
    margin: "1em 0",
  },
  "& ul, & ol": {
    ...theme.typography.textBase500,
    color: theme.palette.dsBase.v200,
    marginLeft: "1.5em",
  },
  "& li": {
    marginBottom: "0.5em",
  },
  "& a": {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  "& img": {
    maxWidth: "100%",
    height: "auto",
    maxHeight: "500px",
    objectFit: "contain",
  },
  "& code": {
    fontFamily: "monospace",
    backgroundColor: theme.palette.background.paper,
    padding: "0.2em 0.4em",
    borderRadius: "3px",
  },
  "& pre": {
    backgroundColor: theme.palette.background.paper,
    padding: "1em",
    borderRadius: "4px",
    overflow: "auto",
  },
}));
